export default "__VITE_ASSET__CzacAeLJ__"